export const getFirstName = (name: string) => {
  if (name !== "") {
    let firstName = name.split(" ")[0].toLowerCase();
    firstName = firstName[0].toLocaleUpperCase() + firstName.substring(1);
    return firstName;
  }
  return "";
};
